export function getApiUrlForEnv(dev = false) {
  const hostname = window && window.location && window.location.hostname

  if (dev) {
    return 'http://localhost'
  }

  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL
  }

  if (
    hostname === 'app.bed-booking.com' ||
    hostname === 'react.bed-booking.com' ||
    hostname === 'pwa.bed-booking.com'
  ) {
    return 'https://api.bed-booking.com'
  } else if (hostname === 'localhost') {
    return 'http://192.168.10.88'
  } else if (hostname === 'bedbooking.dev-effectivity.pl') {
    return 'https://api-rc.bed-booking.com'
  } else {
    return 'https://api-rc.bed-booking.com'
  }
}

export function getUrlForPhoto() {
  const hostname = window && window.location && window.location.hostname

  if (process.env.REACT_APP_PHOTO_URL) {
    return process.env.REACT_APP_PHOTO_URL
  }

  if (
    hostname === 'app.bed-booking.com' ||
    hostname === 'pwa.bed-booking.com'
  ) {
    return 'https://api.bed-booking.com'
  } else {
    return 'https://api-rc.bed-booking.com'
  }
}

export function getPanelUrlForEnv() {
  const hostname = window && window.location && window.location.hostname

  if (process.env.REACT_APP_PANEL_URL) {
    return process.env.REACT_APP_PANEL_URL
  }

  if (
    hostname === 'app.bed-booking.com' ||
    hostname === 'pwa.bed-booking.com'
  ) {
    return 'https://panel.bed-booking.com'
  } else {
    return 'https://rc.bed-booking.com'
  }
}
